var _path, _path2, _rect, _rect2, _rect3, _rect4, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAsphaltShingleRoofing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "asphalt-shingle-roofing",
    fill: "none",
    viewBox: "0 0 52 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m29.316 23.395-7.1089-14.013h-10.174l-11.348 22.206h2.7392l10.174-19.869 7.2179 13.675",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m48.316 25.395-12.021-24.194h-12.131l-3.9132 8.1813h2.7393l2.7392-5.8438 12.087 21.856",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.967,
    y: 22.154,
    width: 1.3479,
    height: 2.5063,
    stroke: "currentColor"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14.098,
    y: 22.154,
    width: 1.3479,
    height: 2.5063,
    stroke: "currentColor"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10.967,
    y: 26.829,
    width: 1.3479,
    height: 2.5063,
    stroke: "currentColor"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 14.098,
    y: 26.829,
    width: 1.3479,
    height: 2.5063,
    stroke: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m12.816 9.3948 3 6c1.5 2.5 3.5 1 3 0l-3-6",
    stroke: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m25.316 1.3948 3.4549 6.5145c1.7274 2.7144 4.0307 1.0858 3.4549 0l-3.4549-6.5145",
    stroke: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m28.538 1.1846 3.5907 6.7184c1.8247 2.8171 4.5412 1.3331 3.9427 0.21335l-3.5907-6.7184",
    stroke: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m32.316 1.3948 3.4549 6.5145c1.7274 2.7144 4.0307 1.0858 3.4549 0l-3.4549-6.5145",
    stroke: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m29.316 8.6051 3.4549 6.5145c1.7274 2.7144 4.0307 1.0858 3.4549 0l-3.4549-6.5145",
    stroke: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m32.538 8.3948 3.5907 6.7184c1.8247 2.8171 4.5412 1.3331 3.9427 0.2134l-3.5907-6.7184",
    stroke: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m36.316 8.6051 3.4549 6.5145c1.7274 2.7144 4.0307 1.0858 3.4549 0l-3.4549-6.5145",
    stroke: "currentColor"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m33.316 16.605 3.4549 6.5145c1.7274 2.7144 4.0307 1.0858 3.4549 0l-3.4549-6.5145",
    stroke: "currentColor"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m37.316 24.605 3.4549 6.5145c1.7274 2.7144 4.0307 1.0858 3.4549 0l-3.4549-6.5145",
    stroke: "currentColor"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m36.538 16.395 3.5907 6.7184c1.8247 2.8171 4.5412 1.3331 3.9427 0.2134l-3.5907-6.7184",
    stroke: "currentColor"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m40.538 24.395 3.5907 6.7184c1.8247 2.8171 4.5412 1.3331 3.9427 0.2134l-3.5907-6.7184",
    stroke: "currentColor"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m40.316 16.605 3.4549 6.5145c1.7274 2.7144 4.0307 1.0858 3.4549 0l-3.4549-6.5145",
    stroke: "currentColor"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m44.316 24.605 3.4549 6.5145c1.7274 2.7144 4.0307 1.0858 3.4549 0l-3.4549-6.5145",
    stroke: "currentColor"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m16.316 9.3948 3 6c1.5 2.5 3.5 1 3 0l-3-6",
    stroke: "currentColor"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m19.316 9.3948 3 6c1.5 2.5 3.5 1 3 0l-3-6",
    stroke: "currentColor"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m16.316 16.395 3 6c1.5 2.5 3.5 1 3 0l-3-6",
    stroke: "currentColor"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m19.816 16.395 3 6c1.5 2.5 3.5 1 3 0l-3-6",
    stroke: "currentColor"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m22.816 16.395 3 6c1.5 2.5 3.5 1 3 0l-3-6",
    stroke: "currentColor"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m19.316 22.395 3 6c1.5 2.5 3.5 1 3 0l-3-6",
    stroke: "currentColor"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m22.816 22.395 3 6c1.5 2.5 3.5 1 3 0l-3-6",
    stroke: "currentColor"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m25.816 22.395 3 6c1.5 2.5 3.5 1 3 0l-3-6",
    stroke: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsphaltShingleRoofing);
export default __webpack_public_path__ + "static/media/asphalt-shingle-roofing.c41fc7a23da73dba96efd651b5907f93.svg";
export { ForwardRef as ReactComponent };